export default __webpack_public_path__ + "static/media/level.d7a35d34.svg";